module.exports = __webpack_public_path__ + "static/media/Lima_Advisory.b9a2b23e.pdf";